export default __webpack_public_path__ + "static/media/Copyright.309baa55.svg";